// import moment from 'moment'
import { Helmet } from 'react-helmet'
import React, { Component } from 'react'
// import $ from 'jquery'; 

class FormPage extends Component {
    // constructor() {
    //     super()
    // }

    componentDidMount() {
        setTimeout(() => {
            // window.addEventListener("load", function() {
            if (window.typeformEmbed && window.typeformEmbed.makeWidget) {
                console.log(document.getElementById("form-container").dataset.form)
                if (document.getElementById("form-container").dataset.form) {
                    window.typeformEmbed.makeWidget(document.getElementById("form-container"), "https://form.typeform.com/to/" + document.getElementById("form-container").dataset.form + "?nocache=" + Math.floor(Math.random() * 9999), {
                        hideFooter: true,
                        hideHeaders: true,
                        opacity: 100
                    });

                    var iFrame = document.querySelector('iframe');
                    resizeIFrameToFitContent(iFrame);
                }
            } else {
                this.componentDidMount()
            }
            // });
        }, 300);
    }

    render() {
        var sc = document.createElement("script");
        sc.setAttribute("type", "text/javascript");
        sc.setAttribute("src", "https://embed.typeform.com/embed.js")
        document.head.appendChild(sc);
        // var formToLoad = this.props.params.slug;
        // var el = document.createElement("div");
        console.log(this.props.params.slug)


        return [
            <Helmet key="1">
                <title>Startup Guide - Form</title>
                <meta content="" name="description" />

                <meta content="website" property="og:type" />
                <meta content="Startup Guide - Form" property="og:title" />
                <meta content="" property="og:description" />
                <meta content="" property="og:image" />
                <meta property="og:url" content={"https://startupguide.com/form/" + this.props.params.slug}></meta>
                <meta property="og:site_name" content="StartupGuide"></meta>

                <meta name="twitter:card" content="summary_large_image"></meta>
                <meta name="twitter:site" content="@StartupGuideHQ"></meta>
                <meta name="twitter:creator" content="@StartupGuideHQ"></meta>
                <meta name="twitter:title" content=""></meta>
                <meta name="twitter:description" content=""></meta>
                <meta name="twitter:image" content=""></meta>
            </Helmet>,
            <div id="form-container" style={{ "height": "90vh", "textAlign": "center" }} key="2" data-form={this.props.params.slug} >Loading form...</div>
        ]
    }
}

function resizeIFrameToFitContent(iFrame) {
    // iFrame.width  = iFrame.contentWindow.document.body.scrollWidth;
    // iFrame.height = iFrame.contentWindow.document.body.scrollHeight;
    console.log(iFrame)
}

export default FormPage
